import { useIsMobile } from './useIsMobile';
import './Header.css';
import DesktopHeader from './DesktopHeader';
import MobileHeader from './MobileHeader';
import SettingsDrawer from './SettingsDrawer';

import React, { useState, useEffect, useRef } from 'react';
// import {
//   Badge,
//   Button,
//   Form,
//   ListGroup,
//   Modal,
//   Navbar,
//   Overlay,
//   Popover,
// } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { shouldShowOnboardingLogout, shouldShowPostOnboardingNav } from '../../utils/navVisibility';
// import Logo from '../../images/SKIP.svg';
import './Header.css';
import { useRealtimeNotificationStore } from '../../store/realtimeNotificationStore';
import { useSessionStore } from '../../store/sessionStore';
// import { ReactComponent as DownIcon } from '../../images/chevron-down.svg';
// import { BellFill, Check2, Trash } from 'react-bootstrap-icons';
// import { io } from 'socket.io-client';
// import HeaderCalendarButton from './HeaderCalendarButton';
interface HeaderProps {
  onToggleSidebar: () => void;
  fullWidthHeader?: boolean;
}

const Header = ({ onToggleSidebar, fullWidthHeader = false }: HeaderProps) => {
  const isMobile = useIsMobile();
  const location = useLocation();

  const [showNotifications, setShowNotifications] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const userData = useSessionStore((s) => s.currentUser) as {
    id?: number;
    profileImg?: string;
    username?: string;
    fname?: string;
    lname?: string;
    firstName?: string;
    lastName?: string;
    onboardingCompleted?: boolean;
  } | null;
  const [isDropdownOpen] = useState<boolean>(false);
  const userNotificationData = useRealtimeNotificationStore((s) => s.items);

  const bellRef = useRef<HTMLButtonElement | null>(null);
  const overlayRef = useRef<HTMLDivElement | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unlockSpeech = () => {
      if ('speechSynthesis' in window) {
        // Create a silent utterance (empty string)
        const utterance = new SpeechSynthesisUtterance('');
        utterance.volume = 0; // 👈 mute so you don’t hear "ready"
        window.speechSynthesis.speak(utterance);
        console.log('Speech unlocked');
      }
      document.removeEventListener('click', unlockSpeech);
    };

    document.addEventListener('click', unlockSpeech);

    return () => {
      document.removeEventListener('click', unlockSpeech);
    };
  }, []);

  // const visibleNotifications = showAll
  //   ? userNotificationData
  //   : userNotificationData.slice(0, 7);

  // const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const settingsMenuRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handleOutside(e: MouseEvent) {
      const target = e.target as Node;
      if (settingsMenuRef.current && !settingsMenuRef.current.contains(target)) {
        // setIsSettingsOpen(false);
      }
    }
    if (isDropdownOpen) document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, [isDropdownOpen]);

  useEffect(() => {
    if (!userData && localStorage.getItem('accessToken')) {
      void useSessionStore
        .getState()
        .bootstrapSession()
        .catch((error: unknown) => {
          const status = (error as { response?: { status?: number } })?.response?.status;
          if (status === 401 || status === 403) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            navigate('/', { replace: true });
          }
        });
    }
  }, [navigate, userData]);

  // Close overlay when clicking outside
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        overlayRef.current &&
        !overlayRef.current.contains(event.target as Node) &&
        !bellRef.current?.contains(event.target as Node)
      ) {
        setShowNotifications(false);
      }
    }

    if (showNotifications) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showNotifications]);

  // const accessToken = localStorage.getItem('accessToken');

  // const toggleDropdown = () => {
  //   setDropdownOpen((prev) => !prev);
  // };

  // const handleLogout = async () => {
  //   localStorage.removeItem('accessToken');
  //   localStorage.removeItem('refreshToken');
  //   navigate('/', { replace: true });
  // };

  const unreadCount = userNotificationData.filter((n) => !n.isRead).length;

  /*  const goToSettings = () => {
    navigate('/user-settings');
    setDropdownOpen(false);
  }; */

  // return (
  //   <>
  //     <div className="header-container">
  //       <Navbar className="mobile-header" variant="light">
  //         {/* New: Mobile Nav Icon */}
  //         <div className="mobile-nav-icon" onClick={onToggleSidebar}>
  //           ☰ {/* Or use an SVG if you prefer */}
  //         </div>

  //         <Navbar.Brand as={Link} to="/user-profile" className="logo">
  //           <img alt="Logo" src={Logo} className="site-logo" width={120} />
  //         </Navbar.Brand>
  //         <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  //       </Navbar>

  //       {accessToken && (
  //         <nav style={{ position: 'relative' }}>
  //           <div className="header-user-data-wrapper">
  //             {/* <span style={{ margin: 'auto' }}>
  //               <span className="down-arrow">
  //                 <BellIcon style={{ width: '0px', height: '20px' }} />
  //               </span>
  //             </span> */}
  //             <HeaderCalendarButton />
  //             <Button
  //               variant="light"
  //               ref={bellRef}
  //               onClick={() => setShowNotifications(!showNotifications)}
  //               className="position-relative"
  //             >
  //               <BellFill size={20} />
  //               {userNotificationData?.some((n: any) => !n.isRead) && (
  //                 <Badge
  //                   bg="danger"
  //                   pill
  //                   className="position-absolute top-0 start-100 translate-middle"
  //                   style={{ fontSize: '0.6rem' }}
  //                 >
  //                   {userNotificationData.filter((n: any) => !n.isRead).length}
  //                 </Badge>
  //               )}
  //             </Button>
  //             {userData?.profileImg ? (
  //               <button
  //                 onClick={toggleDropdown}
  //                 className="flex items-center gap-1"
  //                 style={{ border: 'none', backgroundColor: 'transparent' }}
  //               >
  //                 <img
  //                   src={userData.profileImg}
  //                   alt="Profile Avatar"
  //                   className="preview-avatar-wrapper"
  //                   style={{ width: '40px', height: '40px' }}
  //                 />
  //                 <span className="down-arrow flex items-center justify-center leading-none">
  //                   <DownIcon style={{ width: '20px', height: '20px' }} />
  //                 </span>
  //               </button>
  //             ) : (
  //               <button
  //                 title="Click to open user settings"
  //                 className="header-avatar"
  //                 onClick={toggleDropdown}
  //               ></button>
  //             )}
  //           </div>
  //           {isDropdownOpen && (
  //             <div
  //               className="user-settings-dropdown header-dd"
  //               ref={settingsMenuRef}
  //               // keep this container; we style it below
  //             >
  //               {/* SETTINGS (opens submenu instead of navigating) */}
  //               {userData.username && (
  //                 <div className="dd-row has-sub">
  //                   <button
  //                     type="button"
  //                     title="Go to settings (account, security, privacy, etc.)"
  //                     className="dd-btn"
  //                     aria-haspopup="true"
  //                     aria-expanded={isSettingsOpen}
  //                     onClick={() => setIsSettingsOpen((v) => !v)}
  //                   >
  //                     <span className="dd-label">Settings</span>
  //                     <span
  //                       className={`dd-caret ${isSettingsOpen ? 'open' : ''}`}
  //                     >
  //                       ▸
  //                     </span>
  //                   </button>

  //                   {isSettingsOpen && (
  //                     <div className="dd-sub">
  //                       {settingsItems.map((it) =>
  //                         it.key === 'delete' ? (
  //                           <button
  //                             key={it.key}
  //                             type="button"
  //                             className="dd-subitem danger"
  //                             onClick={() => setShowDeleteModal(true)}
  //                             title="Delete or deactivate your account"
  //                           >
  //                             <span>{it.label}</span>
  //                           </button>
  //                         ) : (
  //                           <button
  //                             key={it.key}
  //                             type="button"
  //                             className="dd-subitem"
  //                             aria-disabled="true"
  //                             onClick={handleSoon}
  //                             title="Coming soon"
  //                           >
  //                             <span>{it.label}</span>
  //                             {it.badge && (
  //                               <span className="dd-chip">{it.badge}</span>
  //                             )}
  //                             <span className="dd-soon">Soon</span>
  //                           </button>
  //                         ),
  //                       )}
  //                     </div>
  //                   )}
  //                 </div>
  //               )}

  //               {/* LOGOUT (active) */}
  //               <div className="dd-row">
  //                 <button
  //                   type="button"
  //                   className="dd-btn danger"
  //                   onClick={handleLogout}
  //                 >
  //                   Logout
  //                 </button>
  //               </div>
  //             </div>
  //           )}
  //         </nav>
  //       )}
  //     </div>

  //     {/* Notification Popover */}
  //     <Overlay
  //       target={bellRef.current}
  //       show={showNotifications}
  //       placement="bottom-end"
  //       rootClose
  //       onHide={() => setShowNotifications(false)} // 👈 closes on outside click
  //     >
  //       {(props) => (
  //         <Popover {...props} style={{ minWidth: '250px', ...props.style }}>
  //           <Popover.Header className="bg-success text-white" as="h6">
  //             Notifications
  //           </Popover.Header>
  //           <Popover.Body className="p-0">
  //             {!userNotificationData || userNotificationData.length === 0 ? (
  //               <div className="text-center py-2">No notifications</div>
  //             ) : (
  //               <ListGroup variant="flush">
  //                 {/* Show either 7 or all depending on toggle */}
  //                 {visibleNotifications.map((n: any) => (
  //                   <ListGroup.Item
  //                     key={n.id}
  //                     className={`d-flex justify-content-between align-items-start ${!n.isRead ? 'fw-bold' : ''}`}
  //                     style={{ fontSize: '0.9rem' }}
  //                   >
  //                     {/* Left: text */}
  //                     <div
  //                       style={{ cursor: 'pointer', flex: 1 }}
  //                       onClick={async () => {
  //                         // Scroll to the reference-card
  //                         const element =
  //                           document.getElementById('references-card');
  //                         if (element) {
  //                           element.scrollIntoView({
  //                             behavior: 'smooth',
  //                             block: 'center',
  //                           });
  //                         }
  //                         // Mark notification as read
  //                         await markNotificationAsRead(n.id);
  //                       }}
  //                     >
  //                       {n.message}
  //                       <br />
  //                       <small className="text-muted">
  //                         {n.createdAt
  //                           ? new Date(n.createdAt).toLocaleString()
  //                           : new Date().toLocaleString()}
  //                       </small>
  //                     </div>

  //                     {/* Right: actions */}
  //                     <div className="d-flex align-items-center gap-2">
  //                       {!n.isRead && (
  //                         <Check2
  //                           size={16}
  //                           style={{ cursor: 'pointer', color: 'green' }}
  //                           onClick={async () => {
  //                             try {
  //                               setUserNotificationData((prev: any) =>
  //                                 prev.map((notif: any) =>
  //                                   notif.id === n.id
  //                                     ? { ...notif, isRead: true }
  //                                     : notif,
  //                                 ),
  //                               );
  //                               await markNotificationAsRead(n.id);
  //                             } catch (err) {
  //                               console.error('Failed to mark as read', err);
  //                             }
  //                           }}
  //                         />
  //                       )}

  //                       <Trash
  //                         size={16}
  //                         style={{ cursor: 'pointer', color: 'red' }}
  //                         onClick={async () => {
  //                           try {
  //                             await deleteNotification(n.id);
  //                             setUserNotificationData((prev: any) =>
  //                               prev.filter((notif: any) => notif.id !== n.id),
  //                             );
  //                           } catch (err) {
  //                             console.error(
  //                               'Failed to delete notification',
  //                               err,
  //                             );
  //                           }
  //                         }}
  //                       />
  //                     </div>
  //                   </ListGroup.Item>
  //                 ))}

  //                 {/* Add "+X more" if there are more than 7 */}
  //                 {userNotificationData.length > 7 && (
  //                   <ListGroup.Item
  //                     action
  //                     className="text-center text-primary fw-bold"
  //                     style={{ fontSize: '0.9rem', cursor: 'pointer' }}
  //                     onClick={() => setShowAll(!showAll)}
  //                   >
  //                     {showAll
  //                       ? 'Show less'
  //                       : `+${userNotificationData.length - 7} more`}
  //                   </ListGroup.Item>
  //                 )}
  //               </ListGroup>
  //             )}
  //           </Popover.Body>
  //         </Popover>
  //       )}
  //     </Overlay>

  //     <Modal
  //       show={showDeleteModal}
  //       onHide={() => setShowDeleteModal(false)}
  //       centered
  //     >
  //       <Modal.Header closeButton>
  //         <Modal.Title>
  //           {deleteMode === 'delete' ? 'Delete account' : 'Deactivate account'}
  //         </Modal.Title>
  //       </Modal.Header>

  //       <Modal.Body>
  //         <div className="mb-3">
  //           <Form.Check
  //             type="radio"
  //             id="delete-mode-delete"
  //             name="delete-mode"
  //             label="Delete permanently"
  //             checked={deleteMode === 'delete'}
  //             onChange={() => setDeleteMode('delete')}
  //           />
  //           <div className="text-muted small ms-4 mb-2">
  //             Irreversible. Your profile, uploads, and personal data will be
  //             removed. Some records (e.g., invoices) may be retained where
  //             legally required or anonymised.
  //           </div>

  //           <Form.Check
  //             type="radio"
  //             id="delete-mode-deactivate"
  //             name="delete-mode"
  //             label="Deactivate (can be reactivated later)"
  //             checked={deleteMode === 'deactivate'}
  //             onChange={() => setDeleteMode('deactivate')}
  //           />
  //           <div className="text-muted small ms-4">
  //             Your profile becomes invisible and logins are blocked. Data is
  //             retained.
  //           </div>
  //         </div>

  //         {deleteMode === 'delete' && (
  //           <>
  //             <div className="border rounded p-2 bg-light mb-2 small">
  //               To confirm, type <strong>DELETE</strong> below.
  //             </div>
  //             <Form.Control
  //               type="text"
  //               placeholder="Type DELETE to confirm"
  //               value={confirmText}
  //               onChange={(e) => setConfirmText(e.target.value)}
  //             />
  //           </>
  //         )}
  //       </Modal.Body>

  //       <Modal.Footer>
  //         <Button
  //           variant="secondary"
  //           onClick={() => setShowDeleteModal(false)}
  //           disabled={isDeleting}
  //         >
  //           Cancel
  //         </Button>

  //         {deleteMode === 'deactivate' ? (
  //           <Button
  //             variant="warning"
  //             onClick={async () => {
  //               try {
  //                 setIsDeleting(true);
  //                 await deactivateUserAccount();
  //                 toast.success('Account deactivated');
  //                 // revoke local auth & redirect
  //                 localStorage.removeItem('accessToken');
  //                 localStorage.removeItem('refreshToken');
  //                 navigate('/', { replace: true });
  //               } catch (e) {
  //                 toast.error('Failed to deactivate account');
  //               } finally {
  //                 setIsDeleting(false);
  //               }
  //             }}
  //             disabled={isDeleting}
  //           >
  //             {isDeleting ? 'Working...' : 'Deactivate'}
  //           </Button>
  //         ) : (
  //           <Button
  //             variant="danger"
  //             onClick={async () => {
  //               if (confirmText !== 'DELETE') {
  //                 toast.info('Please type DELETE to confirm.');
  //                 return;
  //               }
  //               try {
  //                 setIsDeleting(true);
  //                 await deleteUserAccount();
  //                 toast.success('Account deleted');
  //                 localStorage.removeItem('accessToken');
  //                 localStorage.removeItem('refreshToken');
  //                 navigate('/', { replace: true });
  //               } catch (e) {
  //                 toast.error('Failed to delete account');
  //               } finally {
  //                 setIsDeleting(false);
  //               }
  //             }}
  //             disabled={isDeleting}
  //           >
  //             {isDeleting ? 'Deleting...' : 'Delete account'}
  //           </Button>
  //         )}
  //       </Modal.Footer>
  //     </Modal>
  //   </>
  // );

  const showNavChrome = shouldShowPostOnboardingNav(location.pathname, userData);
  const showOnboardingLogout = shouldShowOnboardingLogout(
    location.pathname,
    Boolean(localStorage.getItem('accessToken'))
  );

  return (
    <div className={fullWidthHeader ? 'header-shell header-shell--full-width' : 'header-shell'}>
      {isMobile ? (
        <MobileHeader
          onToggleSidebar={onToggleSidebar}
          onOpenNotifications={() => navigate('/notifications')}
          onOpenSettings={() => setShowSettings(true)}
          unreadCount={unreadCount}
          userData={userData}
          showNavChrome={showNavChrome}
          showOnboardingLogout={showOnboardingLogout}
          fullWidthHeader={fullWidthHeader}
        />
      ) : (
        <DesktopHeader
          onOpenNotifications={() => setShowNotifications(true)}
          onOpenSettings={() => setShowSettings(true)}
          unreadCount={unreadCount}
          userData={userData}
          showOnboardingLogout={showOnboardingLogout}
          fullWidthHeader={fullWidthHeader}
        />
      )}

      <SettingsDrawer
        isMobile={isMobile}
        show={showSettings}
        onClose={() => setShowSettings(false)}
      />
    </div>
  );
};

export default Header;
